import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import {
  CheckCircle as CheckCircleIcon,
  Assessment as AssessmentIcon,
  PendingActions as PendingIcon,
} from '@mui/icons-material'
import { DashboardCard } from './DashboardCard'

export interface DashboardStats {
  completionRate: number
  averageScore: number
  pendingCount: number
  totalEnrollments: number
  completedCount: number
}

interface RiskOverviewProps {
  stats: DashboardStats
}

export const RiskOverview: React.FC<RiskOverviewProps> = ({ stats }) => {
  const { t } = useTranslation('dashboard')

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
        gap: { xs: 2, sm: 3 },
        mb: 3,
      }}
    >
      <DashboardCard
        title={t('riskOverview.completionRate', '完了率')}
        value={`${stats.completionRate}%`}
        icon={<CheckCircleIcon />}
        color="primary"
      />
      <DashboardCard
        title={t('riskOverview.averageScore', '平均スコア')}
        value={stats.averageScore.toString()}
        icon={<AssessmentIcon />}
        color="secondary"
      />
      <DashboardCard
        title={t('riskOverview.pendingCount', '未受講者')}
        value={`${stats.pendingCount}${t('riskOverview.people', '人')}`}
        icon={<PendingIcon />}
        color={stats.pendingCount > 0 ? 'secondary' : 'success'}
      />
    </Box>
  )
}
